import { Box, BoxProps, Flex } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer, { FooterProps } from './Footer/Footer';
import Header, { HeaderProps } from './Header/Header';

export interface LayoutProps extends BoxProps {
  children?: ReactNode;
  headerProps?: HeaderProps;
  containerProps?: BoxProps;
  footer?: boolean;
  footerProps?: FooterProps;
  mainProps?: BoxProps;
}

const DefaultLayout = ({
  children,
  containerProps,
  headerProps,
  footer = true,
  footerProps,
  mainProps,
}: LayoutProps): ReactElement | null => (
  <>
    <Flex direction="column" align="stretch" minH="100%" w="100%" {...containerProps}>
      <Header {...headerProps} />
      <Box as="main" {...mainProps}>
        {children}
      </Box>
      {footer && <Footer mt="auto" {...footerProps} />}
    </Flex>
    <Helmet>
      <style>{`body{overflow:initial}`}</style>
    </Helmet>
  </>
);

export default DefaultLayout;
